import { createSlice, PayloadAction } from "@reduxjs/toolkit"

interface CourseAuditStateProps {
  auditLogsHeartbeatStarted: boolean
  auditLogsCompleteData: any
}

const initialState: CourseAuditStateProps = {
  auditLogsHeartbeatStarted: false,
  auditLogsCompleteData: {
    event_id: "",
    widget_code: "smart_nudges_goal_setting_tracking",
    action_performed: null,
    payload: {
      seg_id: "segment_no",
      input_params_obj: {
        current_goal: "current_goal_na",
        target_date: new Date(Date.now()).toISOString().split("T")[0] || Date.now(),
        user_motivation: "medium",
        consider_history: false,
        custom_instructions: "Remind me weekly and suggest small achievable milestones.",
      },
      assessment_obj: {},
      blob_uri: {
        complete_blob_uri: [],
        generated_blob_uri: [],
        uploaded_blob_uri: [],
        downloaded_blob_uri: [],
      },
      compute_time: 0,
      tokens_used: 0,
      cache_hit: false,
      session_timeout: false,
      usage_time_in_sec: 0,
      watch_percentage: 0,
      video_duration: 0,
    },
  },
}

const GoalSettingAuditSlice = createSlice({
  name: "goal-setting-audit",
  initialState,
  reducers: {
    setAuditLogsHeartbeatStarted: (state, action: PayloadAction<boolean>) => {
      state.auditLogsHeartbeatStarted = action.payload
    },
    setAuditLogsCompleteData: (state, action: PayloadAction<any>) => {
      state.auditLogsCompleteData = action.payload
    },
    resetState: () => initialState,
  },
})

export const { resetState, setAuditLogsCompleteData, setAuditLogsHeartbeatStarted } = GoalSettingAuditSlice.actions
export default GoalSettingAuditSlice.reducer
